<template lang="pug">
  .contact-confirm-switch(@click.stop="onSwitch()")
    //- input(type="checkbox" v-model="switchValue")
    input(type="checkbox" v-model="_value")
    label.switch-label()
        span
    .switch-img
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * ON/OFFを切り替えるスイッチコンポーネント
 */
@Component
export default class StatusSwitch extends Vue {
  /**
   * 親コンポーネントから受け取るスイッチの値
   */
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  /**
   * 本コンポーネントのチェックボックスに紐づくスイッチの値
   */
  // private switchValue: boolean = false;

  /**
   * 親コンポーネントから渡された値に変更があった場合、スイッチの値を同期する
   */
  // @Watch("value")
  // changeSwitchValue(newValue: boolean): void {
  //   this.switchValue = newValue;
  //   return;
  // }

  /**
   * vue lifecycle created
   *
   * 親コンポーネントから渡されてきた値でスイッチの値を初期化する
   */
  // created(): void {
  //   this.switchValue = this.value;
  //   return;
  // }

  get _value(): boolean {
    return this.value;
  }

  /**
   * スイッチ切り替え時イベント
   */
  onSwitch(): void {
    this.$emit("input", !this.value);
    this.$emit("onSwitch");
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

// ボタン領域
.contact-confirm-switch {
  line-height: 34px;
  letter-spacing: 0;
  text-align: center;
  position: relative;
  width: 104px;

  // チェックボックス
  input[type="checkbox"] {
    display: none;
  }

  // リンクであることが分かるようにカーソルを変える
  cursor: pointer;

  // ラベル
  label.switch-label {
    display: block;
    box-sizing: border-box;
    height: 36px;
    border: 2px solid $switch-bordercolor;
    border-radius: 4px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 0;
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
  }

  // ラベル(ON)
  input[type="checkbox"]:checked + label {
    // ON時の枠線
    border-color: $font-key-color;
  }

  // 表示する文字(OFF)
  label span:after {
    content: "未完了";
    padding: 0 0 0 28px;
    color: $switch-bordercolor;
  }

  // 表示する文字(ON)
  input[type="checkbox"]:checked + label span:after {
    content: "完了";
    padding: 0 28px 0 0;
    color: $font-key-color;
  }

  // トグル部分
  .switch-img {
    position: absolute;
    width: 28px;
    height: 28px;
    background: $switch-bordercolor;
    top: 4px;
    left: 4px;
    border-radius: 2px;
    transition: 0.4s;
  }

  // トグル部分(ON)
  input[type="checkbox"]:checked ~ .switch-img {
    transform: translateX(68px);
    background: $font-key-color;
  }
}
</style>
